import React, { Component, Fragment } from 'react'
import Captcha from 'react-captcha'
import axios from 'axios'

import data from '../_main_data'

class ContactForm extends Component{
    state = {
        sent: false,
        email:  '',
        phone: '',
        text: '',
        reCaptchaToken: '',
        errors: [],
        sending: false
    }

    renderErrors(){
        return (
            <Fragment>
            {this.state.errors.map((error, key) => {
                return (<div key={key}><small><i className="fas fa-exclamation-triangle"></i></small>&nbsp;{error}</div>)
            })}
            </Fragment>
        )
    }

    formSubmit = (e) => {
        e.preventDefault()

        let errors = []

        if(!this.state.reCaptchaToken){
            errors.push('Ujistěte nás, že nejste robot')
        }

        if(this.state.email === ''){
            errors.push('Zadejte svůj e-mail ve správném tvaru')
        } 

        if(this.state.text === ''){
            errors.push('Zadejte text své zprávy')
        }

        if(errors.length !== 0){
            this.setState({ errors })
        } else {
            this.sendEmail()
        }
    }

    sendEmail() {
        const settings = data.settings.contactFormServer

        const { phone, email, text } = this.state

        const tel = phone ? `<strong>Telefon: </strong>${phone}\n\n` : ''

        const mail = {
            email: email,
            text: tel + text
        }

        const mailData = {
            mailSettings: settings,
            email: mail
        }

        this.setState({ sending: true })
        axios.post(`${settings.backendServer}/mailform`, mailData)
            .then(() => {
                this.setState({ sending: false, email: '', text: '', sent: true })
            })
            .catch(error => {
                let errors = []

                errors.push(error.message)
                this.setState({ errors, sending: false })
            })
    }

    render() {
        if (!this.state.sent) {
            return (
                <form onSubmit={this.formSubmit}>
                    <h4>Napište nám</h4>
                    <div className="form-group">
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Zadejte svůj e-mail"
                            value={this.state.email}
                            onChange={e => this.setState({ email: e.target.value })}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Zadejte svůj telefon"
                            value={this.state.phone}
                            onChange={e => this.setState({ phone: e.target.value })}
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            className="form-control"
                            rows="6"
                            placeholder="Zadejte text Vaší zprávy"
                            value={this.state.text}
                            onChange={e => this.setState({ text: e.target.value })}
                        />
                    </div>
                    <Captcha
                        sitekey='6LfggkUUAAAAAL3rLWkH7gSuA308vo6WMJxETMOH'
                        lang='cs'
                        theme='light'
                        type='image'
                        callback={(value) => this.setState({ reCaptchaToken: value })} />
                    <button type="submit" className="btn btn-primary mt-3" disabled={this.state.sending}>
                        {this.state.sending ?
                            (<span><i className="fas fa-at fa-spin" />&nbsp;Odesílám</span>)
                            : (<span><i className="fas fa-envelope" />&nbsp;Odeslat</span>)
                        }
                    </button>
                    <div style={{ color: 'red' }} className="mt-3">{this.renderErrors()}</div>
                </form>
            )
        } else {
            return (
                <div className="card">
                    <div className="card-header"><strong className="card-title">Děkujeme!</strong></div>
                    <div className="card-body text-center">
                        <h2 className="text-success">Vaše zpráva byla úspěšně odeslána</h2>
                    </div>  
                </div>
            )
        }
    }
}

export default ContactForm


// WEBPACK FOOTER //
// ./src/components/ContactForm.js